import Swiper from 'swiper/bundle';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

export default {
    name : 'swiper--products',

    init()
    {
        const items = document.querySelectorAll('.swiper--products');
        if (items.length) {
            setTimeout(this.run.bind(this), 100);
        }
        
    },
    setArrows(el){
        
        let img = el.querySelector("img");
        let buttons = el.querySelectorAll(".js-swiper-button");
       

        img?.addEventListener("load", e => {
            let imageHeight = img.clientHeight;
            let imageTop = img.getBoundingClientRect().top;
            let elTop = el.getBoundingClientRect().top;
            console.log(imageHeight);
            buttons.forEach(btn => {
                btn.style.top = (imageTop - elTop) + imageHeight / 2 + "px";
            });
        });
       
    },
    run ()
    {
        const collections = document.querySelectorAll('.swiper--products');

        if (!collections) {
            return false;
        }

        const sliderIds = [];
        collections.forEach( (element) => {
            sliderIds.push(element.id)
        });
        
        document.querySelectorAll('.js-swiper-nav-container').forEach(el=> {
            this.setArrows(el);
        });
        
        const sliders = [];
    
        if (sliderIds.length) {
            for (let i=0; i<sliderIds.length;i++) {
                sliders[i] = new Swiper('#'+sliderIds[i] , {
                    slidesPerView: 1,
                    spaceBetween: 16,
                    freeMode: true,
                    pagination : {
                        el: '.'+sliderIds[i]+".swiper-pagination",
                        type: 'progressbar'
                    },
                    navigation: {
                        nextEl: '.'+sliderIds[i]+ ".swiper-button-next",
                        prevEl: '.'+sliderIds[i] + ".swiper-button-prev",
                    },

                    breakpoints: {
                        640: {
                          slidesPerView: 2
                        },
                        768: {
                          slidesPerView: 3
                        },
                        1280: {
                          slidesPerView: 4
                        }
                    }
                });
            }

        }
    } // run

} // export